import { render } from "./ServicesView.vue?vue&type=template&id=bbcc30b6"
import script from "./ServicesView.vue?vue&type=script&lang=js"
export * from "./ServicesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__